/**
 * Service application class
 *
 * @namespace APP
 * @name APP.Service
 */
APP.Service = (/** @lends APP.Service */function () {
	'use strict';

	var requestCounter = 0,
		$body;

	function init() {
		$body = APP.Performance.getCachedDOM().$body;
	}

	function post(data, url) {
		return load('post', data, url);
	}

	function get(data, url) {
		return load('get', data, url);
	}

	function closeLoader() {
		if(!requestCounter) {
			$body.removeClass('sc--loading');
		}
	}

	function load(type, data, url) {
		var ajaxPromise;

		requestCounter++;
		$body.addClass('sc--loading');

		ajaxPromise = $.ajax({
			url: url,
			type: type,
			data: data,
			dataType: 'json',
			cache: false,
			xhrFields: {
				withCredentials: true
			}
		});

		ajaxPromise.done(function () {
			--requestCounter;
			closeLoader();
		}).fail(function () {
			--requestCounter;
			closeLoader();
		});

		return ajaxPromise;

	}


	return {
		init: init,
		get: get,
		post: post
	};

}());
